module.exports = __webpack_public_path__ + "media/components/assets/bottle_01-4f2593c012914cc1f4487be0c1b78cab.png";